import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { TooltipDirective } from '@shared/directives';
import { TooltipPosition } from '@shared/models';

@Component({
  selector: 'b2c-tooltip',
  styleUrl: './tooltip.component.scss',
  imports: [TooltipDirective],
  templateUrl: './tooltip.component.html',
})
export class TooltipComponent extends BaseComponent {
  alt = input.required<string>();
  icon = input.required<string>();
  content = input.required<string>();

  width = input<string>('20px');
  position = input<TooltipPosition>('above');
}
